import { ShipDataType } from "@/types/apiTypes";
import { getToken } from "@/utils/authHelpers";
import axios from "axios";
import { API_BASE_URL } from "@/utils/api";

export const fetchShipsApi = async (
  shipSearchTerm: string,
  selectedProjectId: string | null,
): Promise<ShipDataType[]> => {
  const token = await getToken();
  if (!token) {
    throw new Error("Authorization token is required");
  }

  try {
    const response = await axios.post<ShipDataType[]>(
      `${API_BASE_URL}/general-search`,
      {
        search_term: shipSearchTerm || "",
        search_type: "ships",
        project_id: selectedProjectId || null,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch ships", error);
    throw error;
  }
};
